import type { ISocialOffer } from "@bbj-types/offer";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Button, Stack, Typography } from "@mui/material";
import clsx from "clsx";
import dompurify from "isomorphic-dompurify";
import { classes } from "../styles";
import { useSocialOfferDescription } from "./logics";

interface ISocialOfferDescriptionProps {
  offer: ISocialOffer;
  setDrawerOffer: (offer: ISocialOffer | null) => void;
}

export const SocialOfferDescription = ({ offer, setDrawerOffer }: ISocialOfferDescriptionProps) => {
  const { maxHeight, estimatedLineCount, contentRef, containerRef } = useSocialOfferDescription();

  return (
    <Stack className={clsx(classes.section, classes.description)} ref={containerRef}>
      {offer.description && (
        <>
          <Typography variant="subtitle1SemiBold">Présentation du service</Typography>
          <div
            ref={contentRef}
            style={{
              maxHeight: maxHeight,
              overflow: "hidden",
              position: "relative",
              display: "-webkit-box",
              WebkitLineClamp: String(estimatedLineCount),
              WebkitBoxOrient: "vertical",
              textOverflow: "ellipsis",
            }}
            // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized with dompurify
            dangerouslySetInnerHTML={{
              __html: dompurify.sanitize(offer.description || ""),
            }}
          />
        </>
      )}
      <Button
        variant="outlined"
        onClick={() => setDrawerOffer(offer)}
        startIcon={<VisibilityOutlinedIcon />}
        sx={{
          mt: 1,
          width: "70%",
        }}
      >
        Afficher toute l'offre
      </Button>
    </Stack>
  );
};
